/* tslint:disable */
/* eslint-disable */
/**
 * True one Services API
 * True one service for form Builder
 *
 * The version of the OpenAPI document: 4.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SectionItem } from './SectionItem';
import {
    SectionItemFromJSON,
    SectionItemFromJSONTyped,
    SectionItemToJSON,
    SectionItemToJSONTyped,
} from './SectionItem';

/**
 * 
 * @export
 * @interface TemplateSection
 */
export interface TemplateSection {
    /**
     * 
     */
    id?: string;
    /**
     * 
     */
    title?: string;
    /**
     * 
     */
    description?: string;
    /**
     * 
     */
    areaId?: string;
    /**
     * 
     */
    areaName?: string;
    /**
     * 
     */
    order?: number;
    /**
     * 
     */
    items?: Array<SectionItem>;
}

/**
 * Check if a given object implements the TemplateSection interface.
 */
export function instanceOfTemplateSection(value: object): value is TemplateSection {
    return true;
}

export function TemplateSectionFromJSON(json: any): TemplateSection {
    return TemplateSectionFromJSONTyped(json, false);
}

export function TemplateSectionFromJSONTyped(json: any, ignoreDiscriminator: boolean): TemplateSection {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'title': json['title'] == null ? undefined : json['title'],
        'description': json['description'] == null ? undefined : json['description'],
        'areaId': json['areaId'] == null ? undefined : json['areaId'],
        'areaName': json['areaName'] == null ? undefined : json['areaName'],
        'order': json['order'] == null ? undefined : json['order'],
        'items': json['items'] == null ? undefined : ((json['items'] as Array<any>).map(SectionItemFromJSON)),
    };
}

export function TemplateSectionToJSON(json: any): TemplateSection {
    return TemplateSectionToJSONTyped(json, false);
}

export function TemplateSectionToJSONTyped(value?: TemplateSection | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'title': value['title'],
        'description': value['description'],
        'areaId': value['areaId'],
        'areaName': value['areaName'],
        'order': value['order'],
        'items': value['items'] == null ? undefined : ((value['items'] as Array<any>).map(SectionItemToJSON)),
    };
}

